<div class="rounded-pill bg-orange text-center text-white py-2" style="min-height: 40px;"><strong>{{ orderService.orderStatus }}</strong></div>
